export default __webpack_public_path__ + "static/cta-block-icon-a3c812fb4536e8ccdb8b79aec2539180.svg";